// Import necessary dependencies from React and Material-UI
import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

/**
 * PaginationControlled component provides a controlled pagination component.
 * @param {function} handlePageChange - Function to handle page change.
 * @param {number} page - Current active page.
 * @returns {JSX.Element} - PaginationControlled component.
 */
export default function PaginationControlled({handlePageChange, page}) {

  return (
    // Stack component to control layout and spacing
    <Stack alignItems="center" spacing={2}>
      {/* Pagination component with primary color and custom styles */}
      <Pagination
        color="primary"
        sx={{button: {color: '#ffffff'}, div: {color: '#ffffff'}}}
        count={10}  // Total number of pages
        page={page}  // Current active page
        onChange={handlePageChange}  // Callback function for page change
      />
      <br/>
    </Stack>
  );
}
